import React from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import Articals from '../Knowledgebase/KnowledgeBase/Articals';
import ArticeVideo from './ArticeVideo';
import FAQFeaturesTutorial from './FeaturesTutorial';
import Questionss from './Questions';

const FAQContentContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='FAQ' parent='FAQ' title='FAQ' />
      <div className='faq-wrap'>
        <Row>
          <Articals />
          <Questionss />
          <FAQFeaturesTutorial />
          <ArticeVideo />
        </Row>
      </div>
    </Container>
  );
};
export default FAQContentContainer;
